import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import store from "./store";
import { Provider } from "react-redux";
import { Account } from "./Accounts";
import { transitions, positions, Provider as AlertProvider } from "react-alert";
import AlertTemplate from "react-alert-template-basic";
import "bootstrap/dist/css/bootstrap.min.css";
import { PersistGate } from "redux-persist/integration/react";
import { persistedStore } from "./store";

const options = {
  position: positions.MIDDLE,
  timeout: 5000,
  offset: "30px",
  transition: transitions.SCALE,
};

// store.subscribe(() => console.log(store.getState()));
ReactDOM.render(
  <Account>
    <React.StrictMode>
      <Provider store={store}>
        <PersistGate persistor={persistedStore}>
          <AlertProvider template={AlertTemplate} {...options}>
            <App />
          </AlertProvider>
        </PersistGate>
      </Provider>
    </React.StrictMode>
  </Account>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
